import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NgClass, NgFor, NgIf } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatOption } from "@angular/material/core";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { TicketsService } from "src/app/tickets/tickets.service";
import { Area } from "src/app/shared/model/tickets/area.model";
import { Puesto } from "src/app/shared/model/empleado/puesto.model";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";

type AreaListState = {
  currentPage?: number;
  pageSize?: number;
};

@Component({
  selector: "app-modal-areas",
  standalone: true,
  templateUrl: "./modal-area.component.html",
  imports: [NgIf, NgClass, NgFor, FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOption, MatSlideToggleModule, MatIconModule],
})
export class ModalAreaComponent implements OnInit {
  consultaObject = new ConsultaList<Puesto>();
  totalRegistros = 0;
  pageSize = 3;
  readonly pageSizeOptions = [3, 5];
  currentPage = 1;
  loadingPuestos = false;

  area: Area = this.createAreaBase();
  puesto = new Puesto();
  puest = "";
  puestoList: Puesto[] = [];
  bandTabla = false;
  bandEdit = false;
  indexEdit = -1;
  isEditMode = false;
  tituloOperacion = "Alta";
  private readonly listRoute = "/admin/areas";
  private listState: AreaListState | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private msg: Msg,
    private ticketsService: TicketsService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if (!this.initializeRouteContext()) {
      return;
    }

    queueMicrotask(() => {
      this.consultaPagina(1);
      this.cdr.detectChanges();
    });
  }

  consultaPagina(page: number): void {
    this.currentPage = page;

    if (this.area?.id === undefined || this.area?.id === null) {
      this.totalRegistros = this.puestoList.length;
      this.bandTabla = this.puestoList.length > 0;
      this.area.listPuesto = this.puestoList;
      this.loadingPuestos = false;
      this.cdr.detectChanges();
      return;
    }

    this.loadingPuestos = true;
    this.cdr.detectChanges();
    this.consultaObject.regInicial = (page - 1) * this.pageSize;
    this.consultaObject.regXPagina = this.pageSize;
    this.consultaObject.regFinal = this.pageSize;
    this.consultaObject.param6 = this.area.id;

    this.ticketsService.consultarPuestoPorAreaPaginacion(this.consultaObject).subscribe({
      next: (res) => {
        this.puestoList = Array.isArray(res?.list) ? res.list : [];
        this.totalRegistros = this.resolveTotalRegistros(res);
        this.bandTabla = this.puestoList.length > 0;
        this.area.listPuesto = this.puestoList;
        this.loadingPuestos = false;

        if (!this.bandTabla && page === 1) {
          this.msg.warningCall("Area sin puestos para mostrar", null, null);
        }

        const maxPages = this.totalPages;
        if (maxPages > 0 && this.currentPage > maxPages) {
          this.consultaPagina(maxPages);
          return;
        }

        this.cdr.detectChanges();
      },
      error: () => {
        this.puestoList = [];
        this.totalRegistros = 0;
        this.bandTabla = false;
        this.area.listPuesto = [];
        this.loadingPuestos = false;
        this.cdr.detectChanges();
      },
    });
  }

  guardarActualizar(): void {
    if (!this.validarFormulario()) {
      this.msg.warningCall("Campos vacios, favor de validar el formulario", null, null);
      return;
    }

    this.ticketsService.guardarArea(this.area).subscribe((res) => {
      if (+res.pCodRetorno === 0) {
        this.area = this.hydrateArea(res);
        this.msg.successCall("Area guardada con exito", null, () => this.navigateBackToList());
      } else {
        this.msg.warningCall("No se pudo guardar el area", null, null);
      }
    });
  }

  validarFormulario(): boolean {
    if (this.area.area == null || this.area.area === "") {
      return false;
    }
    if (this.area.estatus == null || this.area.estatus === "") {
      return false;
    }
    if (this.area.listPuesto === undefined) {
      return false;
    }

    return true;
  }

  back(): void {
    this.navigateBackToList();
  }

  confirmacionAreaDefault(element: any): void {
    this.msg.questionCall(
      "Desea marcar esta area como default para atencion de tickets?",
      null,
      (res) => {
        if (!res.value) {
          element.checked = false;
          this.area.defaultService = false;
          this.cdr.detectChanges();
        }
      },
    );
  }

  altaModificarPuesto(): void {
    this.puesto = new Puesto();
    const totalPuestos = this.totalRegistros > 0 ? this.totalRegistros : this.puestoList.length;

    if (totalPuestos >= 5) {
      this.msg.warningCall(
        "La capacidad de registros llego al limite, guarde para poder agregar mas registros.",
        null,
        null,
      );
      return;
    }

    if (this.puest === "") {
      this.msg.warningCall("El campo Nombre del Puesto esta vacio.", null, null);
      return;
    }

    let seAgregoPuesto = false;
    if (!this.bandEdit) {
      this.puesto.puesto = this.puest;
      this.puesto.estatus = "ACTIVO";
      this.puestoList.push(this.puesto);
      seAgregoPuesto = true;
    } else {
      this.puestoList[this.indexEdit].puesto = this.puest;
    }

    this.puest = "";
    this.bandEdit = false;
    this.indexEdit = -1;
    this.area.listPuesto = this.puestoList;
    this.bandTabla = true;
    this.totalRegistros = this.area?.id
      ? seAgregoPuesto
        ? totalPuestos + 1
        : totalPuestos
      : this.puestoList.length;
    this.currentPage = this.totalPages > 0 ? this.totalPages : 1;
    this.cdr.detectChanges();
  }

  modifica(row: Puesto, index: number): void {
    this.puest = row.puesto;
    this.bandEdit = true;
    this.indexEdit = this.area?.id ? index : (this.currentPage - 1) * this.pageSize + index;
    this.cdr.detectChanges();
  }

  onClicAcualizaStatus(row: Puesto, event: any): void {
    row.estatus = event.checked ? "ACTIVO" : "BAJA";
    this.area.listPuesto = this.puestoList;
  }

  onPageSizeChange(value: number): void {
    this.pageSize = Number(value);
    this.consultaPagina(1);
  }

  onPageChange(page: number): void {
    if (page === this.currentPage || page < 1 || page > this.totalPages) {
      return;
    }
    this.consultaPagina(page);
  }

  firstPage(): void {
    this.onPageChange(1);
  }

  previousPage(): void {
    this.onPageChange(this.currentPage - 1);
  }

  nextPage(): void {
    this.onPageChange(this.currentPage + 1);
  }

  lastPage(): void {
    this.onPageChange(this.totalPages);
  }

  get visiblePuestos(): Puesto[] {
    if (this.area?.id !== undefined && this.area?.id !== null) {
      return this.puestoList;
    }

    const start = (this.currentPage - 1) * this.pageSize;
    return this.puestoList.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    return this.totalRegistros > 0 ? Math.ceil(this.totalRegistros / this.pageSize) : 0;
  }

  get showPagination(): boolean {
    return this.bandTabla && (this.totalRegistros > 0 || this.puestoList.length > 0);
  }

  get rangeEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalRegistros);
  }

  getPaginationItems(): Array<number | string> {
    if (this.totalPages <= 1) {
      return [1];
    }

    const pages = new Set<number>([
      1,
      this.totalPages,
      this.currentPage - 1,
      this.currentPage,
      this.currentPage + 1,
    ]);

    const sortedPages = Array.from(pages)
      .filter((page) => page >= 1 && page <= this.totalPages)
      .sort((a, b) => a - b);

    const items: Array<number | string> = [];
    for (let index = 0; index < sortedPages.length; index++) {
      const page = sortedPages[index];
      const previous = sortedPages[index - 1];
      if (previous && page - previous > 1) {
        items.push(`ellipsis-${previous}-${page}`);
      }
      items.push(page);
    }

    return items;
  }

  isPageNumber(item: number | string): item is number {
    return typeof item === "number";
  }

  private initializeRouteContext(): boolean {
    this.listState = (history.state?.listState as AreaListState) || null;
    this.isEditMode = this.route.snapshot.paramMap.has("id");
    const areaState = history.state?.area as Area | undefined;

    if (this.isEditMode) {
      if (!areaState) {
        queueMicrotask(() => {
          this.msg.warningCall(
            "Seleccione nuevamente el area desde la gestion para editarla.",
            null,
            () => this.navigateBackToList(),
          );
        });
        return false;
      }

      this.area = this.hydrateArea(areaState);
      this.tituloOperacion = "Edicion";
      return true;
    }

    this.area = this.createAreaBase();
    this.tituloOperacion = "Alta";
    return true;
  }

  private navigateBackToList(): void {
    this.router.navigate([this.listRoute], {
      state: this.listState ? { listState: this.listState } : undefined,
    });
  }

  private createAreaBase(): Area {
    const area = new Area();
    area.estatus = "ACTIVO";
    area.tipo = "RESOLUTORA";
    area.defaultService = false;
    area.listPuesto = [];
    return area;
  }

  private hydrateArea(source: Area): Area {
    const area = Object.assign(this.createAreaBase(), source || {});
    area.listPuesto = Array.isArray(source?.listPuesto) ? [...source.listPuesto] : [];
    return area;
  }

  private resolveTotalRegistros(res: ConsultaList<Puesto>): number {
    const response = res as ConsultaList<Puesto> & Record<string, unknown>;
    const candidates = [
      response?.pTotalItems,
      response?.totalItems,
      response?.totalRegistros,
      response?.param4,
    ];

    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }
    }

    const currentItems = Array.isArray(res?.list) ? res.list.length : 0;
    if (currentItems === 0) {
      return 0;
    }

    return (this.currentPage - 1) * this.pageSize + currentItems;
  }
}
